import React, {useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import { Row, Col, Card, CardBody, Container } from "reactstrap";
import { FormGroup, SaveButton } from "components/common";
import { compose, withState, withStateHandlers } from "recompose";
import { LocalForm, Control } from "react-redux-form";
import { Trans, withTranslation } from "react-i18next";
import { ApiClient, } from "services";
import { NotificationManager } from "react-notifications";
import { useOrganisationContext } from "hooks";
import LoadingMsg from "components/common/LoadingMsg";
import { priceForRemainingDays } from "../../Helpers"
import { formatDateName } from "services/util";

const useSelection = () => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleToggle = (feature) => {
    if (selectedItems.some(item => item.object_id === feature.object_id)) {
      setSelectedItems(selectedItems.filter(item => item.object_id !== feature.object_id));
    } else {
      setSelectedItems([...selectedItems, feature]);
    }
  };

  return [selectedItems, handleToggle];
};

export const CustomizeSubscription = ({
  item,
  form,
  setDispatch,
  onUpdate,
  onChange,
  location,
  t
}) => {
  
  const retrievedAppName = new URLSearchParams(location?.search).get('app_name');
  
  const { search } = useLocation();
  const [redirecting, setRedirecting] = useState();
  const [priceValue, setPriceValue] = useState();
  const [currency, setCurrency] = useState('SAR');
  const [currentSubscriptionData, setCurrentSubscriptionData] = useState({});
  const [organisationBillingAddressData, setOrganisationBillingAddressData] = useState()

  const [promoCodeData, setPromoCodeData] = useState(null)

  const { selectedOrganisation } = useOrganisationContext();  

  const client = ApiClient()

  const connectedOrg = selectedOrganisation ? selectedOrganisation?.id : 0

  const [applicationData, setApplicationData] = useState();
  const [languageData, setlanguageData] = useState();

  const [selectedLang, handleLanguageToggle] = useSelection();
  const [selectedApp, handleAppToggle] = useSelection();

  const searchParams = new URLSearchParams(search)
  const fromPage = searchParams.get('from')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseL = await client.get("core/hesaab_language");
        const ldata = responseL.data;
        setlanguageData(ldata);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    const fetchApplicationData = async () => {
      try {
        const responseApp = await client.get("core/hesaab_application")
        setApplicationData(responseApp.data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchApplicationData()

    const fetchSubscriptionData = async () => {
      if (connectedOrg !== 0) {
        try {
          const res = await client.get(`connected_organisations/${connectedOrg}/subscription`);
          const data = res.data;
          setCurrentSubscriptionData(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }  

    fetchSubscriptionData();

    const fetchBillingAddressData = async () => {
      if (connectedOrg !== 0) {
        try {
          const res = await client.get(`connected_organisations/${connectedOrg}/billing-address`);
          const data = res.data;
          setOrganisationBillingAddressData(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }  

    fetchBillingAddressData()
  }, [selectedOrganisation]);

  let currentPlan = currentSubscriptionData?.current_plan

  let remainingDays = currentPlan?.remaining_subscription_days

  let showPrice = 0

  function snakeToTitle(str) {
    return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  const responseError = "No Response from the server, please try again"

  const handlePost = async () => {
    let selectedFeatures = [...selectedApp, ...selectedLang].map(feature => ({
      object_id: feature.id,
      content_type: feature.content_type,
    }))

    let postData = {
      features: selectedFeatures,
      billing_address: organisationBillingAddressData?.default_address?.id,
    }

    let endpoint = `/update-subscription/${currentPlan.id}`

    client.post(endpoint, postData)
      .then(response => {
          NotificationManager.success(t('Details Confirmed, You will be re-directed to payment!'));
          setTimeout(() => {
            setRedirecting(true)
            if (response.data.id) {
            client.post(`/payment`, {invoice: response?.data?.id})
              .then(res => {
              NotificationManager.success(t('Payment details sent to TAP!'));
              setTimeout(() => {
                if (res?.data.transaction_url) {
                window.location.href = res?.data.transaction_url;
              } else {
                NotificationManager.error(t(responseError))
                setRedirecting(false)
                return
              }
              }, 500);
            })} else {
              NotificationManager.error(t(responseError))
              setRedirecting(false)
              return
            }
          }, 500);
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const fieldName = snakeToTitle(key);
            const errorMessage = `${fieldName} - ${value}`;
            if (errorMessage === "Connected Organisation - Invalid pk \"0\" - object does not exist.") {
              NotificationManager.error(t("Your connected organisation cannot be determined"))
            } else {
            NotificationManager.error(errorMessage)
          }
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
      });
  };

  const showTotalPrice = (subTotal, vatAmount = 0, discountedAmount = 0) => {
    return (subTotal + vatAmount - (discountedAmount || 0)).toFixed(2)
  }

  let purchasedLanguages = currentPlan?.subscribed_feature_list?.filter(item => item.content_type_name === 'hesaablanguage').map(item => item.object_id)

  let purchasedApplications = currentPlan?.subscribed_feature_list?.filter(item => item.content_type_name === 'hesaabapplication').map(item => item.object_id)

  const onChangeModule = (feature, currentPlan, contentType) => {
    if (contentType === 'hesaablanguage') {
      handleLanguageToggle(feature)
    } else if (contentType === 'hesaabapplication') {
      handleAppToggle(feature)
    }
  }

  useEffect(() => {
    let priceValue = calculateTotalPrice([...selectedLang, ...selectedApp], currentPlan)
    setPriceValue(priceValue)
  }, [selectedLang, selectedApp])

  const calculateTotalPrice = (selectedFeatures, currentPlan) => {
    let totalPrice = 0

    if (!selectedFeatures) return totalPrice

    for (let feature of selectedFeatures) {
      if (currentPlan?.billing_cycle === 'Yearly') {
        totalPrice += parseFloat(feature?.yearly_price?.price || 0)
      } else if (currentPlan?.billing_cycle === 'Monthly') {
        totalPrice += parseFloat(feature?.monthly_price?.price || 0)
      }
    }

    return totalPrice
  }
  
  const getPrice = (item, currentPlan) => {
    let priceInfo = currentPlan?.billing_cycle === 'Yearly' ? item.yearly_price : item.monthly_price

    if (!priceInfo) return '-'

    return `${priceInfo?.currency} ${priceInfo?.price}`
  }

  showPrice = priceForRemainingDays(priceValue, currentPlan?.billing_cycle, remainingDays)

  const applicationMapping = retrievedAppName ? applicationData?.filter(i => i?.code === retrievedAppName) : applicationData

  return (
  <div className='payment-summary'>
    <Container>
      <Row>
        <Col xs={false}>
          <Card>
            <CardBody>
                {redirecting ? <LoadingMsg message="Redirecting"/> :
                 <LocalForm
                    initialState={item}
                    onSubmit={values => handlePost(values)}
                    getDispatch={setDispatch}
                    onUpdate={onUpdate}
                    onChange={onChange}
                  >

                <div className="row">
                  <div className="col-md-7 col-lg-8">
                    <h4 className="mb-3">Add new features to current subscription</h4>
                      {
                        currentSubscriptionData && currentSubscriptionData?.current_plan && 
                        <div className="alert alert-warning" role="alert">
                          <span><Trans>Your current subscription is valid till <strong>{ formatDateName(currentSubscriptionData?.current_plan?.next_renewal_date) }</strong>. The validity and price of the newly added features will be adjusted based on the current subscription period.</Trans></span>
                        </div>
                      }

                    { fromPage === 'lang' && 
                      <Row>
                        <Col md="12" xs={false}>
                            <span className="d-print-none card-title">Languages</span>
                            <table className="table table-sm border" style={{maxWidth:"100%"}}>
                            <thead>
                            <tr>
                                <th className="text-left"><Trans>Name</Trans></th>
                                <th className="text-center"><Trans>{currentPlan?.billing_cycle} Price</Trans></th>
                                <th className="text-right"><Trans>Select</Trans></th>
                            </tr>
                            </thead>
                            <tbody>
                            {languageData?.map((i) => (i.code !== 'ar' &&
                                <tr key={i.id}>
                                    <td className="text-left">{i.name}</td>
                                    <td className="text-center">
                                      { 
                                        getPrice(i, currentPlan)
                                      }
                                    </td>
                                    <td className="text-right">
                                      <Control.checkbox 
                                        model={`.lang-${i.id}`}
                                        checked={selectedLang.includes(i.id)}
                                        onChange={() => onChangeModule(i, currentPlan, 'hesaablanguage')}
                                        disabled={!!purchasedLanguages?.includes(i.id)}
                                      />
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </Col>
                      </Row>
                    }
                    { fromPage === 'app' &&
                      <Row>
                          <Col md="12" xs={false}>
                              <span className="d-print-none card-title">Applications</span>
                              <table className="table table-sm border" style={{maxWidth:"100%"}}>
                              <thead>
                              <tr>
                                  <th className="text-left"><Trans>Description</Trans></th>
                                  <th className="text-center"><Trans>{currentPlan?.billing_cycle} Price</Trans></th>
                                  <th className="text-right"><Trans>Select</Trans></th>
                              </tr>
                              </thead>
                              <tbody>
                              {applicationMapping?.map((i) => (
                                  <tr key={i.id}>
                                      <td className="text-left">{i.name}</td>
                                      <td className="text-center">
                                        { 
                                          getPrice(i, currentPlan)
                                        }
                                      </td>
                                      <td className="text-right">
                                        <Control.checkbox 
                                          model={`.app-${i.id}`}
                                          checked={selectedApp.includes(i.id)}
                                          onChange={() => onChangeModule(i, currentPlan, 'hesaabapplication')}
                                          disabled={!!purchasedApplications?.includes(i.id)}
                                        />
                                      </td>
                                  </tr>
                              ))}
                              </tbody>
                          </table>
                          </Col>
                      </Row>
                    }
                  </div>

                  <div className="col-md-5 col-lg-4">
                    <h4 className="d-flex justify-content-between align-items-center mb-3">
                      <span><Trans>Price summary</Trans></span>
                    </h4>
                    
                    <ul className="list-group mb-3">
                      <li className="list-group-item d-flex justify-content-between lh-sm">
                        <div>
                          <h6 className="my-0"><Trans>Price (One Time)</Trans></h6>
                          <small className="text-muted"><Trans>Selected features price</Trans></small>
                        </div>
                        <strong>{currency} {showPrice || "0.00"}</strong>
                      </li>

                      <li className="list-group-item d-flex justify-content-between">
                        <span><Trans>Sub-total ({ currency })</Trans></span>
                        <strong>{showPrice}</strong>
                      </li>
                      
                      <li className="list-group-item d-flex justify-content-between">
                        <span><Trans>Total ({ currency })</Trans></span>
                        <strong>{ showTotalPrice(showPrice, 0, promoCodeData?.discounted_price) }</strong>
                      </li>
                    </ul>

                    <FormGroup className="mt-4">
                      <SaveButton
                        type="submit"
                        className="btn-primary-filled btn-rounded btn-form-submit btn-rounded"
                        form={form}
                      >
                        <Trans>Continue to Payment</Trans>
                      </SaveButton>
                    </FormGroup>
                  </div>

                  </div>
                  </LocalForm>}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </div>

)
};

const enhance = compose(
  withTranslation(),
  withState("success", "setSuccess", null),
  withState("failure", "setFailure", null),
  withStateHandlers(
    {},
    {
      setFirstNameRef: () => (firstNameRef) => ({ firstNameRef }),
    }
  )
);

export default enhance(CustomizeSubscription);
